import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectFormVersion } from './versioning';

/**
 * Root component for the single-app version switch: shown at the form root
 * while getChildRoutes resolves the version (v1 vs v2). Renders the loading
 * indicator until the matching subtree is available (`children`).
 *
 * RRv3 can skip re-running getChildRoutes after a restart, so this reloads
 * the page if the live version decision no longer matches the mounted one.
 */
export default function FormVersionShell({ children, route }) {
  const liveVersion = useSelector(selectFormVersion);
  const resolvedVersion = route?.resolvedVersion;

  useEffect(() => {
    if (liveVersion && resolvedVersion && liveVersion !== resolvedVersion) {
      window.location.reload();
    }
  }, [liveVersion, resolvedVersion]);

  if (!children) {
    return (
      <va-loading-indicator message="Please wait while we load the application for you." />
    );
  }
  return children;
}

FormVersionShell.propTypes = {
  children: PropTypes.node,
  route: PropTypes.shape({
    resolvedVersion: PropTypes.string,
  }),
};
